import { SubArea } from '@office-start/telemetry-types';

import { ExpandableListModel } from '../directives/expandable-list/expandable-list.model';

export type KnownTabIds = 'following-sharepoint' | 'frequent-sharepoint' | 'folders' | 'Calendar' | 'mru' | 'unpinned-mru' | 'pinned-mru' | 'shared-mru' | 'trending-docs' | 'classNotebook-mru' | 'app-items-mru' | 'app-items-deleted' | 'app-items-forms' | 'groups' | 'groupItemsForms' | 'groupItemsFormsDeleted';

export interface TabItem {
    id: KnownTabIds;
    title: string;
    titleForAnnouncement?: string;
    ariaLabel: string;
    listModel: ExpandableListModel;
    timestampHeader?: string;
    zeroExperienceTitle: string;
    zeroExperienceSubtitle?: string;
    zeroExperienceImage?: string;
    showZeroExperience?: boolean;
    errorTitle: string;
    errorSubtitle?: string;
    errorImage?: string;
    attribution?: TabItemAttribution;
    onLoad?: () => Promise<void>;
    loaded?: boolean;
    hasError?: boolean;
    fromCache?: boolean;
    showCardsInTileView?: boolean;
    footerText?: string;
}

export interface TabItemAttribution {
    onClick?: () => void;
    title: string;
    url?: string;
    tooltip?: string;
    ariaLabel: string;
    referral: string;
    leftAligned?: boolean;
    zeroTitle?: string;
}

export const tabIdToSubArea = new Map<KnownTabIds, SubArea>([
    ['mru', 'Recent'],
    ['unpinned-mru', 'Recent'],
    ['pinned-mru', 'Pinned'],
    ['shared-mru', 'Shared'],
    ['trending-docs', 'Trending'],
    ['classNotebook-mru', 'ClassNotebooks'],
    ['app-items-mru', 'AppItems'],
    ['app-items-forms', 'AppItems'],
    ['app-items-deleted', 'Other'],
    // TODO: ['app-items-deleted', 'Deleted']
    ['groupItemsForms', 'AppItems'],
    ['groupItemsFormsDeleted', 'Other']
    // TODO: ['groupItemsFormsDeleted', 'Deleted']
]);
